"use client";

import { getCurrentUser } from "@aws-amplify/auth";
// import { callClickstreamAPI } from "../server-actions/server-action";
import { currentAuthenticatedUser, getCookie } from "./helper-function";
import { fetchAuthSession } from "@aws-amplify/auth";

import API_URL from "@packages/lib/server-actions/api-urls";
import { getReferrer } from "./getReferrer";

export interface ClickstreamInterface {
  eventType?: any;
  pageName?: any;
  sectionName?: any;
  functionalityName?: any;
  actionType?: any;
  CTATitle?: any;
  videoName?: any;
  videoCategory?: any;
  institutionCountryName?: any;
  idpInstitutionId?: any;
  idpcInstitutionId?: any;
  interestedIntakeYear?: any;
  signupMethod?: any;
  signupFailureReason?: any;
  networkId?: any;
  sessionTrackId?: any;
  userId?: any;
  articleTopic?: any;
  subject?: any;
  ldcs1Code?: any;
  ldcs1CodeDesc?: any;
  ldcs2Code?: any;
  ldcs2CodeDesc?: any;
  ldcs3Code?: any;
  ldcs3CodeDesc?: any;
  paginationNumber?: any;
  studyLevelId?: any;
  studyLevel?: any;
  studyModeId?: any;
  studyMode?: any;
  locationType?: any;
  sortOption?: any;
  searchKeyword?: any;
  browseNodeSubjects?: any;
  SRInstitutionIDOrder?: any;
  orderItemId?: any;
  subOrderItemId?: any;
  isAdvertiser?: any;
  externalUrl?: any;
  clickType?: any;
  displayOrder?: any;
  idpcCourseId?: any;
  idpcCourseName?: any;
  eventId?: any;
  postFlag?: any;
  downloadFlag?: any;
  subjectGrade?: any;
  childStudyLevel?: any;
  childStudyLevelId?: any;
  personaType?: any;
  clearingWebclick?: any;
  campaignId?: any;
  countryOfResidence?: any;
  solusConsent?: any;
}

export async function logClickstreamEvent(data: ClickstreamInterface) {
  console.log(data?.externalUrl, "datainclickstream");
  try {
    if (
      typeof document !== "undefined" &&
      !document.cookie.split("sessionTrackId=")[1]
    ) {
    }
    const isWhatuni = process.env.PROJECT === "Whatuni";
    const pgsUser =
      (typeof document !== "undefined" &&
        document.cookie.split("pgs_userid=")[1]?.split(";")[0]) ||
      "0";
    const tracksession =
      (typeof document !== "undefined" &&
        document.cookie.split("userTrackId=")[1]?.split(";")[0]) ||
      "0";

    const userLoggedIn = isWhatuni
      ? await currentAuthenticatedUser()
      : pgsUser !== "0"
        ? "1"
        : "0";
    const userId = isWhatuni
      ? userLoggedIn === "1"
        ? (await getCurrentUser())?.userId
        : "0"
      : pgsUser !== "0"
        ? pgsUser
        : "0";
    let defaultAttributes = {
      affiliateId: isWhatuni ? "220703" : "607022",
      userloggedIn: userLoggedIn,
      userId: userId,
      sessionTrackId: tracksession,
      userAgent: typeof window !== "undefined" && window.navigator.userAgent,
      siteName: isWhatuni ? "Whatuni" : "PGS",
      refererURL: data?.externalUrl
        ? decodeURIComponent(window.location.href)
        : typeof window !== "undefined" && getReferrer(),
      requestURL: data?.externalUrl
        ? data.externalUrl
        : decodeURIComponent(window.location.href),
      siteLanguage: "English",
      isMobileUser: `${window.innerWidth < 1024 ? "Y" : "N"}`,
      screenResolution:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
      systemname: "Domestic",
      institutionCountryName: "United Kingdom",
      pageName: localStorage.getItem("gaPageName") || "",
      ...(isWhatuni
        ? (getCookie("widgetId") ? { campaignId: getCookie("widgetId") } : {})
        : ((getCookie("campaign_id") || (typeof window !== "undefined" && new URLSearchParams(window.location.search).get("campaign")))
          ? { campaignId: getCookie("campaign_id") || new URLSearchParams(window.location.search).get("campaign") }
          : {})),

    };
    userId && (defaultAttributes = { ...defaultAttributes, userId: userId });
    await callClickstreamAPI({ ...defaultAttributes, ...data });
  } catch (error: any) {
    console.log("ERROR fetching clickstream: ", error);
  }
}

function isBotClient() {
  if (typeof window === "undefined") return true;

  const ua = navigator.userAgent.toLowerCase();
  return /bot|crawler|spider|bingbot|googlebot|duckduckbot|slurp/i.test(ua);
}

async function callClickstreamAPI(payload: any) {
  try {
    if (isBotClient()) {
      return;
    }
    const session = await fetchAuthSession();
    // const tracksession_id = uuidv4().replace(/\D/g, "").slice(0, 8);
    const headers: any = {
      "Content-Type": "application/json",
      "x-api-key": `${process.env.NEXT_PUBLIC_X_API_KEY}`,
      tracksessionid: payload?.sessionTrackId,
    };
    let apiUrl = `${process.env.NEXT_PUBLIC_BFF_API_DOMAIN}`;

    if (session.tokens?.idToken) {
      headers.Authorization = `${session.tokens.idToken}`;
      apiUrl += API_URL?.clickstreamForUser;
    } else {
      apiUrl += API_URL?.clickstreamForGuest;
    }
    const respone = await fetch(apiUrl, {
      method: "POST",
      headers,
      body: payload ? JSON.stringify(payload) : undefined,
    });
  } catch (error: any) {
    console.log("ERROR fetching clickstream: ", error);
  }
}
